import { db } from '@/database/firebase.db';
import { IPark } from '@/models/IPark.model';

export class ParksAPI {

    private db;
    private collection;

    constructor(){
        this.db = db;
        this.collection = this.db.collection('parks');
    }

    async getAll(): Promise<IPark[]>{
        const parkQuery = this.collection.doc('SUMMARY');
        const parkSnapshot = await parkQuery.get();
        const parkDocument = parkSnapshot.data();
        if(parkDocument){
            return Object.values(parkDocument);
        } else {
            return []
        }
        
    }
    async patch(park: IPark): Promise<IPark>{
     
        // Add park
        const parkId = park.id;
        const parkQuery = this.collection.doc(parkId);
        const parkSnapshot = await parkQuery.update(park);

        // Update Summary
        try {
            const parksQuery = this.collection.doc('SUMMARY');
            const parksSnapshot = await parksQuery.get();
            const parksDocument = parksSnapshot.data();
            if (parksDocument) {
                const summaryparks = parksDocument;
                summaryparks[parkId] = park;
                await this.collection.doc('SUMMARY').set(summaryparks);
            } else {
                throw 'Error Updating Park.Summary'
            }
        } catch (err) {
            console.error(err)
        }
        return park;
    }
    async post(park: IPark): Promise<IPark>{
     
        // Add park
        const parkId = park.id;
        const parkQuery = this.collection.doc(parkId);
        const parkSnapshot = await parkQuery.set(park);

        // Update Summary
        try {
            const parksQuery = this.collection.doc('SUMMARY');
            const parksSnapshot = await parksQuery.get();
            const parksDocument = parksSnapshot.data();
            if (parksDocument) {
                const summaryparks = parksDocument;
                summaryparks[parkId] = park;
                await this.collection.doc('SUMMARY').set(summaryparks);
            } else {
                throw 'Error Updating Park.Summary'
            }
        } catch (err) {
            console.error(err)
        }
        return park;
    }
    async delete(park: IPark): Promise<IPark>{
     
        // Add park
        const parkId = park.id;
        const parkQuery = this.collection.doc(parkId);
        const parkSnapshot = await parkQuery.delete();

        // Update Summary
        try {
            const parksQuery = this.collection.doc('SUMMARY');
            const parksSnapshot = await parksQuery.get();
            const parksDocument = parksSnapshot.data();
            if (parksDocument) {
                const summaryparks = parksDocument;
                delete summaryparks[parkId];
                await this.collection.doc('SUMMARY').set(summaryparks);
            } else {
                throw 'Error Updating Park.Summary'
            }
        } catch (err) {
            console.error(err)
        }
        return park;
    }

} 